import { collectAnswerMessageIds, splitTurnSegments, } from "./messageTimeline.js";
export const USER_MESSAGE_RAIL_MIN_ENTRIES = 4;
export const TITLE_MAX_CHARS = 160;
export const ANSWER_MAX_CHARS = 400;
const MARKDOWN_NOISE = [
    [/^\s*```.*$/gm, ""],
    [/!\[[^\]]*\]\([^)]*\)/g, ""],
    [/\[([^\]]+)\]\([^)]*\)/g, "$1"],
    [/^#{1,6}\s+/gm, ""],
    [/^\s*>\s?/gm, ""],
    [/^\s*[-*+]\s+/gm, "• "],
    [/\*\*|__|`/g, ""],
];
export function messagePreviewText(text, maxChars, options = {}) {
    let plain = text;
    for (const [pattern, replacement] of MARKDOWN_NOISE) {
        plain = plain.replace(pattern, replacement);
    }
    plain = options.singleLine
        ? plain.replace(/\s+/g, " ")
        : plain
            .split("\n")
            .map((line) => line.replace(/[ \t]+/g, " ").trim())
            .join("\n")
            .replace(/\n{3,}/g, "\n\n");
    plain = plain.trim();
    return plain.length > maxChars ? `${plain.slice(0, maxChars - 1).trimEnd()}…` : plain;
}
function userMessageTitle(message) {
    const text = messagePreviewText(message.text, TITLE_MAX_CHARS, { singleLine: true });
    if (text.length > 0) {
        return text;
    }
    const names = (message.attachments ?? []).map((attachment) => attachment.name).join(", ");
    return names.length > TITLE_MAX_CHARS
        ? `${names.slice(0, TITLE_MAX_CHARS - 1).trimEnd()}…`
        : names;
}
export function deriveUserMessageRailEntries(timelineEntries, activeTurnInProgress) {
    const segments = splitTurnSegments(timelineEntries);
    const entries = [];
    segments.forEach((segment, index) => {
        const userEntry = segment.userEntry;
        if (userEntry === null) {
            return;
        }
        const live = activeTurnInProgress && index === segments.length - 1;
        const answerIds = collectAnswerMessageIds(segment.entries, live);
        const answerEntry = segment.entries.find((entry) => entry.kind === "message" &&
            answerIds.has(entry.message.id) &&
            entry.message.text.trim().length > 0);
        entries.push({
            messageId: userEntry.message.id,
            title: userMessageTitle(userEntry.message),
            answer: answerEntry !== undefined && answerEntry.kind === "message"
                ? messagePreviewText(answerEntry.message.text, ANSWER_MAX_CHARS)
                : null,
        });
    });
    return entries;
}
export function isUserMessageRailVisible(entries) {
    return entries.length >= USER_MESSAGE_RAIL_MIN_ENTRIES;
}
export function applyUserMessageRailUpdate(current, update) {
    if (update.replace)
        return update.entries;
    const entries = new Map(current.map((entry) => [entry.messageId, entry]));
    for (const entry of update.entries)
        entries.set(entry.messageId, entry);
    return [...entries.values()];
}
